<template>
	<div class="space-popup">
		<div>
			<b-carousel id="carousel1" indicators background="#ababab" :interval="4000" @sliding-start="onSlideStart" @sliding-end="onSlideEnd">

				<!-- Slides with image only -->
				<b-carousel-slide :key="index" v-for="index in slideData[slideName].length" class="img-fluid carousel-item" :img-src="slideData[slideName].prefix + (index/100).toFixed(2).toString().split('.')[1] + slideData[slideName].type">
				</b-carousel-slide>
			</b-carousel>
			<img @click="closeSlide" class="close" src="@/assets/about/corner/btn_back.svg" alt="">
			<div class="card-content">
				<span class="title" v-html="slideData[slideName].titleCh"></span>
				<span v-show="slideData[slideName].state" class="state">{{slideData[slideName].state}}</span>
				<router-link v-show="slideData[slideName].state" @click.native="goTop" to="/rent" tag="span" class="state info">租借詳情 Rental → </router-link>
				<h3 class="title" v-html="slideData[slideName].titleEn"></h3>
				<h4 class="subTitle">{{slideData[slideName].subTitle}}</h4>
				<div class="content" v-html="slideData[slideName].content"></div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
  name: "spacePopup",
  data() {
    return {
      slideData: {
        slide1: {
          length: 10,
          prefix: "/static/assets/corner/A-1F/img_",
          type: ".png",
          state: "可租借",
          titleCh: "藝享基地",
          titleEn: "Main Building",
          subTitle: "1樓 交誼廳  Exhibition Salon",
          content: "展示無獨有偶工作室劇團歷年演出之經典戲偶。適合40人以內的聚會空間。<br><br>Display of the puppets from the former productions of Puppet & Its Double Theater."
        },
        slide2: {
          length: 4,
          prefix: "/static/assets/corner/A-2F/img_",
          type: ".png",
          state: "可租借",
          titleCh: "藝享基地",
          titleEn: "Main Building",
          subTitle: "2樓 多功能簡報室  Meeting Room",
          content: "約可容納20人的交流空間。<br><br>The room has a capacity of 20 audience seats."
        },
        slide3: {
          length: 6,
          prefix: "/static/assets/corner/A-3F/img_",
          type: ".png",
          state: "可租借",
          titleCh: "藝享基地",
          titleEn: "Main Building",
          subTitle: "3樓 休憩空間  Accommodation",
          content: "提供寢具、無線網路、微波爐、冰箱。<br><br>Linen Included, Wi-Fi, Microwave, Fridge."
        },
        slide4: {
          length: 2,
          prefix: "/static/assets/corner/A-4F/img_",
          type: ".png",
          state: "可租借",
          titleCh: "藝享基地",
          titleEn: "Main Building",
          subTitle: "4樓 多功能活動空間  Rehearsal Loft",
          content: "挑高三米，10米x11米，無柱，有落地鏡，適合肢體活動，可裝設簡單燈光音響，供小型演出使用，約可容納七十名觀眾。<br><br>Three meters in height. Around 10m*11m in size. No pillars. With mirror-lined walls, a basic stereo system. The studio has a capacity of 70 audience seats."
        },
        slide5: {
          length: 2,
          prefix: "/static/assets/corner/7/img_",
          type: ".png",
          state: "可租借",
          titleCh: "七號倉",
          titleEn: "Barn No.7",
          subTitle: "排練場  Rehearsal Hall",
          content: "挑高五米，長14米x寬11米，無柱，有落地鏡，備簡單音響（播放器需自備）、四顆 LED PAR(黃光，不可變色)。<br><br>Five meters in height. Around 198m² in size. No pillars. With mirror-lined walls, a basic stereo system (without player) and four LED PARs (in yellow only)."
        },
        slide6: {
          length: 3,
          prefix: "/static/assets/corner/4-1/img_",
          type: ".png",
          state: "可租借",
          titleCh: "四號倉",
          titleEn: "Barn No.4",
          subTitle: "木工廠  Woodshop",
          content: "基礎手動工具、共用工作桌、桌鋸一台、帶鋸機三台、手提線鋸、修邊機、砂輪機兩台、桌上型線鋸機一台、角度切割機一台、鑽床兩台。<br><br>With basic manual tools, shared working tables, a table saw, three band saws, portable jigsaws, trimming machines, two grinders, a desktop jigsaw and an angle cutting machine. Other supplies, including hardware and timber parts, paint sprays and glues, are also provided."
        },
        slide7: {
          length: 1,
          prefix: "/static/assets/corner/4-3/img_",
          type: ".png",
          state: "",
          titleCh: "四號倉",
          titleEn: "Barn No.4",
          subTitle: "製偶教室  Craft Room",
          content: "共用工作桌、各式顏料、雕刻工具、手工材料、基本工具(剪刀、美工刀等)。<br><br>With shared working tables, paints, carving tools, and basic tools (scissors, cutter knives)."
        },
        slide8: {
          length: 1,
          prefix: "/static/assets/corner/4-2/img_",
          type: ".png",
          state: "",
          titleCh: "四號倉",
          titleEn: "Barn No.4",
          subTitle: "縫紉教室 Sewing Room",
          content: "工業用縫紉機兩台、家用縫紉機一台、拷克機一台、三本機一台、共用裁桌、熨斗、基本裁縫工具(布剪、線剪、針、線、粉片、尺等)、各式布料。<br><br>With two industrial sewing machines, a household sewing machine, an overlock machine, a cover stitch machine, shared cutting tables, irons, basic sewing supplies (scissors, needles, pins, threads, chalks and rulers) and all kinds of fabrics. Artists are to bring their own supplies that are not listed here."
        },
        slide9: {
          length: 4,
          prefix: "/static/assets/corner/G/img_",
          type: ".png",
          state: "",
          titleCh: "戶外空間",
          titleEn: "Outdoor Area",
          subTitle: "戶外空間Outdoor Area",
          content: ""
        },
        slide10: {
          length: 4,
          prefix: "/static/assets/corner/6/img_",
          type: ".png",
          state: "可租借",
          titleCh: "六號倉",
          titleEn: "Barn No.6",
          subTitle: "小型展演廳  Performance Studio",
          content: "高約 4 米，長9米x寬7米。約可容納四十名觀眾，備基本燈光（可變色 LED PAR）系統、音響系統、移動式觀眾席、餐飲吧檯。<br><br>Four meters in height. Stage space around 12m² in size. The studio has a capacity of 40 audience seats with basic lighting system (including color changing LED PAR), stereo system, movable seating and a concession stand."
        },
        slide11: {
          length: 1,
          prefix: "/static/assets/corner/OT/img_",
          type: ".png",
          state: "可租借",
          titleCh: "露天劇場",
          titleEn: "Outdoor Theatre",
          subTitle: "",
          content: "面積約 53 坪(175 平方公尺)之有牆面、無屋頂的戶外實驗創作空間。<br><br>Around 175 m² in size, this is a roofless space for outdoor experimental performance."
        },

      }
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true
    },
    onSlideEnd(slide) {
      this.sliding = false
    },
    closeSlide() {
      this.$emit('closeSlide')
    },
    goTop: function () {
      $('html,body').scrollTop(0)
      this.$emit('closeSlide')
    }
  },
  props: {
    slideName: String
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../stylesheet/base.sass'
  @import '../stylesheet/layout.sass'

  .space-popup
    width: 95%
    max-width: 1280px
    position: absolute
    top: 500px
    left: 50%
    z-index: 500
    transform: translateX(-50%) translateY(-50%)
    box-shadow: 3px 3px 17px rgba(0,0,0,0.3)
    @media screen and (max-width: 900px)
      top: 300px

    .close
      +size(30px, 30px)
      position: absolute
      right: 50px
      top: 50px
      opacity: 1
    .card-content
      background-color: white
      padding: 60px
      @media screen and (max-width: 996px)
        padding: 20px
      .title
        font-size: $font-size-1
        font-weight: 500
        line-height: 2
      .subTitle
        font-size: $font-size-3
        margin: 15px 0
        line-height: 2
      .state
        font-size: $font-size-3-s
        color: #01b6e2
        border-radius: 100px
        border: solid 1px #01b6e2
        padding: 0px 12px
        margin-left: 10px
        font-weight: 100
        white-space: nowrap
        margin-bottom: 5px
        margin-top: 10px
        margin-bottom: 10px
      .info
        background-color: #01b6e2
        color: white
        cursor: pointer
      .content

</style>



// WEBPACK FOOTER //
// src/components/space_popup.vue